export default __webpack_public_path__ + "static/media/youtube.36a9779c.jpg";